import React from 'react';
import { COLORS, FONTS } from '../signup/signupStyles';

const TYPE_COLORS = {
  Interview: '#5B8FB9',
  Survey: '#6b8e23',
  'Focus Group': '#8B6DB0',
  'Advisory Board': '#C27B3E'
};

const OpportunityItem = ({ opp, onSelect }) => (
  <div style={{
    backgroundColor: '#fff', borderRadius: '12px', padding: '20px',
    border: `1px solid ${COLORS.border}`,
    display: 'flex', gap: '16px', textAlign: 'left'
  }}>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <span style={{
          fontSize: '11px', fontWeight: '600', textTransform: 'uppercase',
          letterSpacing: '0.5px', color: TYPE_COLORS[opp.type] || COLORS.blue,
          backgroundColor: `${TYPE_COLORS[opp.type] || COLORS.blue}12`,
          padding: '3px 8px', borderRadius: '4px'
        }}>{opp.type}</span>
        <span style={{ fontSize: '13px', color: COLORS.muted }}>{opp.duration}</span>
      </div>
      <p style={{ fontSize: '15px', fontWeight: '600', color: COLORS.text, margin: '0 0 6px' }}>
        {opp.title}
      </p>
      <p style={{ fontSize: '13px', color: COLORS.muted, margin: 0, lineHeight: '1.5' }}>
        {opp.description}
      </p>
    </div>
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'flex-end',
      justifyContent: 'space-between', flexShrink: 0, paddingTop: '2px'
    }}>
      <div>
        <div style={{ fontSize: '20px', fontWeight: '700', color: '#6b8e23', textAlign: 'right' }}>
          {opp.pay}
        </div>
        <div style={{ fontSize: '11px', color: COLORS.muted, textAlign: 'right' }}>
          Compensation
        </div>
      </div>
      <button
        onClick={() => onSelect(opp)}
        style={{
          fontSize: '13px', fontWeight: '600', color: '#fff',
          backgroundColor: COLORS.salmon, padding: '8px 16px',
          borderRadius: '6px', border: 'none', cursor: 'pointer',
          marginTop: '12px', transition: 'opacity 0.2s'
        }}
        onMouseEnter={(e) => { e.target.style.opacity = '0.85'; }}
        onMouseLeave={(e) => { e.target.style.opacity = '1'; }}
      >See details</button>
    </div>
  </div>
);

export const OpportunityCard = ({ opportunities, onSelect }) => (
  <div style={{
    marginTop: '32px', backgroundColor: '#f4f8f0', textAlign: 'left',
    border: '2px solid #B5C9A8', borderRadius: '16px', padding: '28px'
  }}>
    <div style={{
      fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
      letterSpacing: '1px', color: '#6b8e23', marginBottom: '6px'
    }}>Based on your profile</div>
    <h3 style={{
      fontFamily: FONTS.serif, fontSize: '20px', fontWeight: '700',
      color: COLORS.text, margin: '0 0 20px'
    }}>Paid Research Opportunities</h3>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {opportunities.map(opp => (
        <OpportunityItem key={opp.id} opp={opp} onSelect={onSelect} />
      ))}
    </div>
    <p style={{
      fontSize: '13px', color: COLORS.muted, margin: '16px 0 0', textAlign: 'center'
    }}>
      Complete your profile to see all matching opportunities
    </p>
  </div>
);
